import { inject, Injectable } from '@angular/core';
import JSZip from "jszip";
import { FilesForZipScorm2004Service } from 'src/app/files-for-zip-scorm-2004.service';
import { FilesForZipService } from 'src/app/files-for-zip.service';
import { ExportOptionBotType } from 'src/app/routes/ai-bot/admin/tabs/general/embed-tab/embed-tab.component';
import { FrontendUrlsService } from '@shared-angular/services/frontend-urls.service';
import { LanguageService } from '@shared-angular/services/language.service';
import { RouteShareService } from '../route-share.service';


export const getExportFileName = (botName: string, fileEnding: string) => {
  const fileName = botName;
  let sanitizedFileName = fileName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  sanitizedFileName = sanitizedFileName.replace(/_+/g, '_');
  if (sanitizedFileName.endsWith('_')) {
    sanitizedFileName = sanitizedFileName.slice(0, -1);
  }
  return `${sanitizedFileName}.${fileEnding}`;
};

export type ZipExportType = "chat" | "audio" | "avatar" | "fusion";

@Injectable({ providedIn: 'root' })
export class ZipexportService {
  private readonly frontendUrls = inject(FrontendUrlsService);

  constructor(private langService: LanguageService,
    public rss: RouteShareService,
    public zipFiles: FilesForZipService,
    public zipFiles2024: FilesForZipScorm2004Service
  ) {


  }


  public saveAs(blob: Blob, filename: string) {
    const fileURL = URL.createObjectURL(blob);
    const element = document.createElement('a');
    element.setAttribute('href', fileURL);
    element.setAttribute('download', filename);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }




  //public buildZip(exportType: ZipExportType, botConfig: ChatbotConfig, instantAccess: boolean = false, zipName: string = "") {
  public buildZip(exportOptions: ExportOptionBotType, instantAccess: boolean = false, exportType: "scorm" | "scorm2004" | "pod" = "scorm", zipName: string = "") {
    const botConfig = this.rss.botConfig;
    const exportBotType = exportOptions.zipType;
    const zip = new JSZip();
    const baseBotName = zipName;
    let frameUrl = this.frontendUrls.bot(`/user/botScorm/${botConfig._id}`);
    const botName = baseBotName;
    // BOT NORMAL
    let botSrc = `/${this.langService.getLanguage()}/bot/${botConfig._id}/${exportOptions.urlSuffix}`;
    // FV
    if (exportBotType == "fusion" && exportOptions.fusionId) {
      botSrc = `/${this.langService.getLanguage()}/fusion/${botConfig._id}/${exportOptions.fusionId}`;
    }

    if (instantAccess) {
      if (exportBotType == "fusion") {
        botSrc += "?joinGUEST_ID=~~GUEST_ID~~&joinMETADATA=-~~SCORM_USER~~";
      }
      if (exportBotType !== "fusion") {
        botSrc += "/join/~~GUEST_ID~~/-~~SCORM_USER~~";
      }
    }


    frameUrl += "/?runsinlms=true&botsrc=" + encodeURIComponent(botSrc);



    if (exportType === "scorm") {
      zip.file("imsmanifest.xml", this.zipFiles.fileContentManifest(botName));
      zip.file("index.html", this.zipFiles.scormZipIndexHtml(frameUrl, botName));
    }

    if (exportType === "scorm2004") {
      zip.file("imsmanifest.xml", this.zipFiles.fileContentManifest2004(botName));
      zip.file("index.html", this.zipFiles.scormZipIndexHtml2004(frameUrl, botName));
      zip.file("adlcp_v1p3.xsd", this.zipFiles2024.adlcp_v1p3_xsd());
      zip.file("adlnav_v1p3.xsd", this.zipFiles2024.adlnav_v1p3_xsd());
      zip.file("imsss_v1p0.xsd", this.zipFiles2024.imsss_v1p0_xsd());
      zip.file("imscp_v1p1.xsd", this.zipFiles2024.imscp_v1p1_xsd());
      zip.file("adlseq_v1p3.xsd", this.zipFiles2024.adlseq_v1p3_xsd());
    }

    if (exportType === "pod") {
      zip.file("breeze-manifest.xml", this.zipFiles.breeteManifestFile());
      const urlforPodBot = this.frontendUrls.bot(botSrc);
      zip.file("ki-toolbox-pod_html5.htm", this.zipFiles.podIndexHtml(urlforPodBot, botName));
      zip.file("connect_customPodSDK.js", this.zipFiles.ccpSDK());



    }







    zip.generateAsync({ type: "blob" })
      .then((content: Blob) => {
        this.saveAs(content, getExportFileName(baseBotName, "zip"));
      })
      .catch((error: unknown) => {
        console.error("Error generating zip file:", error);
      });
  }





}

